module.exports = __webpack_public_path__ + "static/mpost77.a695f418.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost77.jpg
// module id = 1000
// module chunks = 35783957827783